import React from 'react';
import {Edit, SimpleForm, TextInput} from 'react-admin'
import {regex} from 'react-admin';
import validation from './validation';
import {withTranslation} from 'react-i18next';

const validateUrl = regex(/https:\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/\S*)?/);

const ReceiverEdit = ({t, ...props}) => (
    <Edit {...props} title={t('Create sender')}>
        <SimpleForm redirect={'/receivers'} validate={validation}>
            <TextInput source={'name'} label={t('Name')} autoFocus fullWidth/>
            <TextInput source={'url'} label={t('Url')} validate={validateUrl} fullWidth/>
        </SimpleForm>
    </Edit>
);


export default withTranslation()(ReceiverEdit);